module.exports = __webpack_public_path__ + "media/reference3.8da4dc6c.mp3";